var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 22.5H18.75C20.4069 22.5 21.75 21.1569 21.75 19.5V12.5V8.87939C21.75 8.14611 21.4814 7.43822 20.995 6.88947L19.3469 5.03001L18.0643 3.54161C17.4944 2.88028 16.6647 2.5 15.7917 2.5H12.75H6.75C5.09315 2.5 3.75 3.84314 3.75 5.5V19.5C3.75 21.1569 5.09315 22.5 6.75 22.5ZM16.75 5.08022L17.8409 6.34616L18.8636 7.5H16.75V5.08022ZM14.75 4.5V8.5C14.75 9.05229 15.1977 9.5 15.75 9.5H19.75V12.5V19.5C19.75 20.0523 19.3023 20.5 18.75 20.5H6.75C6.19772 20.5 5.75 20.0523 5.75 19.5V5.5C5.75 4.94772 6.19772 4.5 6.75 4.5H12.75H14.75ZM9.25 14C9.25 13.4477 9.69771 13 10.25 13H11.75V11.5C11.75 10.9477 12.1977 10.5 12.75 10.5C13.3023 10.5 13.75 10.9477 13.75 11.5V13H15.25C15.8023 13 16.25 13.4477 16.25 14C16.25 14.5523 15.8023 15 15.25 15H13.75V16.5C13.75 17.0523 13.3023 17.5 12.75 17.5C12.1977 17.5 11.75 17.0523 11.75 16.5V15H10.25C9.69771 15 9.25 14.5523 9.25 14Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlus);
export default __webpack_public_path__ + "static/media/file_plus.7958db4d6cb422d0a5259afbcc6bcb24.svg";
export { ForwardRef as ReactComponent };